import { useLayoutEffect } from 'react';

const useScrollTo = (x = 0, y = 0, ref = null, dependencies = []) => {
  useLayoutEffect(() => {
    const element = ref?.current ?? window;

    try {
      element.scrollTo({ top: y, left: x });
    } catch (error) {
      // fallback for old browsers
      element.scrollTo(x, y);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
};

export default useScrollTo;
